"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-desktop
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.71
 * Contact: bithighlander@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeepKeySignTxEndpointsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class KeepKeySignTxEndpointsApi extends runtime.BaseAPI {
    /**
     */
    async binanceSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling binanceSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/binanceSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async binanceSignTx(requestParameters, initOverrides) {
        const response = await this.binanceSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async btcSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling btcSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/btcSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.BTCSignedTxFromJSON)(jsonValue));
    }
    /**
     */
    async btcSignTx(requestParameters, initOverrides) {
        const response = await this.btcSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async cosmosSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.cosmosSignTx === null || requestParameters.cosmosSignTx === undefined) {
            throw new runtime.RequiredError('cosmosSignTx', 'Required parameter requestParameters.cosmosSignTx was null or undefined when calling cosmosSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/cosmosSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.CosmosSignTxToJSON)(requestParameters.cosmosSignTx),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CosmosSignedTxFromJSON)(jsonValue));
    }
    /**
     */
    async cosmosSignTx(requestParameters, initOverrides) {
        const response = await this.cosmosSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async eosSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling eosSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/eosSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async eosSignTx(requestParameters, initOverrides) {
        const response = await this.eosSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async ethSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling ethSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/ethSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ETHSignedTxFromJSON)(jsonValue));
    }
    /**
     */
    async ethSignTx(requestParameters, initOverrides) {
        const response = await this.ethSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async osmosisSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling osmosisSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/osmosisSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     */
    async osmosisSignTx(requestParameters, initOverrides) {
        const response = await this.osmosisSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async rippleSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.rippleSignTx === null || requestParameters.rippleSignTx === undefined) {
            throw new runtime.RequiredError('rippleSignTx', 'Required parameter requestParameters.rippleSignTx was null or undefined when calling rippleSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/rippleSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.RippleSignTxToJSON)(requestParameters.rippleSignTx),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.RippleTxFromJSON)(jsonValue));
    }
    /**
     */
    async rippleSignTx(requestParameters, initOverrides) {
        const response = await this.rippleSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async signTransactionRaw(requestParameters, initOverrides) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling signTransaction.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/sign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.SignTransaction200ResponseFromJSON)(jsonValue));
    }
    /**
     */
    async signTransaction(requestParameters, initOverrides) {
        const response = await this.signTransactionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async thorchainSignTxRaw(requestParameters, initOverrides) {
        if (requestParameters.thorchainSignTx === null || requestParameters.thorchainSignTx === undefined) {
            throw new runtime.RequiredError('thorchainSignTx', 'Required parameter requestParameters.thorchainSignTx was null or undefined when calling thorchainSignTx.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // api_key authentication
        }
        const response = await this.request({
            path: `/thorchainSignTx`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.ThorchainSignTxToJSON)(requestParameters.thorchainSignTx),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ThorchainTxFromJSON)(jsonValue));
    }
    /**
     */
    async thorchainSignTx(requestParameters, initOverrides) {
        const response = await this.thorchainSignTxRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.KeepKeySignTxEndpointsApi = KeepKeySignTxEndpointsApi;
